import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AccountActions } from '../../actions/loyalty/actions-account';
import { BackendLoyaltyService } from '../../services/backend-loyalty.service';
import * as AccountAction from '../../actions/loyalty/actions-account';

@Injectable()
export class EffectsAccount {
  getAgentAccount$: Observable<AccountActions> = createEffect(() => {
    return this.actions$.pipe(
      ofType<AccountAction.GetAccount>(AccountAction.GET_ACCOUNT),
      switchMap(() =>
        this.backendLoyaltyService.getAccount().pipe(
          map((data: number) => new AccountAction.GetAccountSuccess(data)),
          catchError(() => of(new AccountAction.GetAccountError('pageSectionIsNotAvailable')))
        )
      )
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly backendLoyaltyService: BackendLoyaltyService
  ) { }
}
